import React from 'react'
import { useThunkDispatch } from 'models/thunk'
import { useQuery } from '@tanstack/react-query'
import { useIntl } from 'react-intl'

import DashboardCard from 'components/Dashboard/DashboardCard/DashboardCard'

import { getIndicator } from 'actions/dashboard'

import './style.scss'

import { IndicatorStatistics } from 'models/dashboard'

interface Props {
  workspaceId: number
}

const IncomeInvoiceCountContainer = ({ workspaceId }: Props) => {
  const thunkDispatch = useThunkDispatch()
  const intl = useIntl()

  const { data, ...query } = useQuery<IndicatorStatistics>(
    ['get-income-invoice-count', workspaceId],
    () => thunkDispatch(getIndicator(workspaceId, 'cfdis'))
  )

  const formatDate = (dateString?: string) => {
    if (!dateString) return '- - -'
    const date = new Date(dateString.split('.')[0])
    const formatted = intl.formatDate(date, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    return formatted
  }

  const indicator = data?.value || 'equal'

  return (
    <DashboardCard
      className="income-invoice-count-container"
      title="CFDIs promedio mensuales"
      titleTag="h3"
      loading={query.isLoading}
      fetching={query.isFetching}
      value={data?.indicator || '- - -'}
      indicator={indicator}>
      {data?.indicator && (
        <p className="most-used">
          Más usada: <span className="value">{data?.mode}</span>
        </p>
      )}
      {data?.indicator && (
        <i className="last">Última creada {formatDate(data?.lastCreated)}</i>
      )}
    </DashboardCard>
  )
}

export default IncomeInvoiceCountContainer
